export default {
  name: "UploadImageSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};